import React from 'react';
import { ReportInlineModuleError } from '@americanexpress/travel-error-base';
import { sanitize } from '@americanexpress/consumer-travel-base';
import { useDataFromOneCMS } from '../../fetchye/advisoryOneCMSFetchye';
import { moduleName } from '../../constants/moduleName';

const AdditionalBanner = () => {
  const additionalBannerData = useDataFromOneCMS('additionalBanner');
  const { isActive = false, icon, content } = additionalBannerData;

  if (!isActive) return null;

  if (!content) {
    return (
      <ReportInlineModuleError
        moduleID={moduleName}
        otherData={{ componentID: 'AdditionalBanner', causes: { oneCmsContent: !content } }}
      />
    );
  }

  return (
    <div id="additionalBannerContainer" className="text-align-center pad-1 container">
      <i
        id="additionalBannerIcon"
        className={`icon ${icon} margin-1-r dls-bright-blue`}
        aria-hidden="true"
      />
      <span
        id="additionalBannerContent"
        dangerouslySetInnerHTML={{ __html: sanitize(content) }}
      />
    </div>
  );
};

export default AdditionalBanner;
